import { render, staticRenderFns } from "./WhiteListRemoved.vue?vue&type=template&id=5dd48a32&scoped=true"
import script from "./WhiteListRemoved.vue?vue&type=script&lang=js"
export * from "./WhiteListRemoved.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd48a32",
  null
  
)

export default component.exports